import './style.css'
import Experience from './experience/Experience'

const canvas = document.querySelector('canvas.webgl')
const experience = new Experience(canvas)